import React, { useState, useRef } from "react";

export default function ImageUpload({ onUpload }) {
    const [images, setImages] = useState([]);
    const fileInputRef = useRef(null);

    const handleImageUpload = (event) => {
        const files = Array.from(event.target.files);

        if (files.length + images.length > 10) {
            alert("You can only upload up to 10 images.");
            return;
        }

        const validFiles = files.filter((file) => file.size <= 5 * 1024 * 1024);
        if (validFiles.length !== files.length) {
            alert("Some files were too large (Max 5MB).");
        }

        const newImages = [...images, ...validFiles];
        setImages(newImages);
        onUpload(newImages.map((file) => URL.createObjectURL(file))); // Send image URLs to parent
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        handleImageUpload({ target: { files } });
    };

    const removeImage = (index) => {
        const newImages = images.filter((_, i) => i !== index);
        setImages(newImages);
        onUpload(newImages.map((file) => URL.createObjectURL(file))); // Update parent
    };

    return (
        <div className="imageUploadContainer">
            <label className="label">Upload Images (Max 10) <span className="asterisk">*</span></label>

            <input 
                type="file" 
                accept="image/*" 
                multiple 
                ref={fileInputRef} 
                onChange={handleImageUpload} 
                style={{ display: "none" }} 
            />

            <div
                className="dropZone"
                onDrop={handleDrop}
                onDragOver={(event) => event.preventDefault()}
            >
                <p>Drag & Drop images here or</p>
                <button type="button" className="imageSelectButton" onClick={() => fileInputRef.current.click()}>Select Images</button>
            </div>

            {images.length > 0 && (
                <div className="imageGrid">
                    {images.map((image, index) => (
                        <div key={index} className="imageItem">
                            <img src={URL.createObjectURL(image)} alt="Property" className="thumbnail" />
                            <button type="button" onClick={() => removeImage(index)}>✖</button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
